import * as React from "react";
import { cn } from "../../lib/utils";

const toolbarButtonBase =
  "px-2 py-1 text-xs rounded-md border bg-background hover:bg-muted text-foreground flex items-center gap-1";

export const RichTextEditor = React.forwardRef(
  ({ value = "", onChange, placeholder, className }, ref) => {
    const internalRef = React.useRef(null);
    const editorRef = ref || internalRef;

    // Sync initial / external value into the editor
    React.useEffect(() => {
      if (editorRef.current && typeof value === "string") {
        if (editorRef.current.innerHTML !== value) {
          editorRef.current.innerHTML = value;
        }
      }
    }, [value, editorRef]);

    const emitChange = () => {
      if (!onChange || !editorRef.current) return;
      const html = editorRef.current.innerHTML;
      onChange(html);
    };

    const handleInput = () => {
      emitChange();
    };

    const exec = (command) => {
      if (typeof document === "undefined") return;
      document.execCommand(command, false, null);
      emitChange();
    };

    const execBlock = (block) => {
      if (typeof document === "undefined") return;
      document.execCommand("formatBlock", false, block);
      emitChange();
    };

    return (
      <div
        className={cn(
          "border rounded-md bg-background text-foreground",
          className
        )}
      >
        <div className="flex flex-wrap items-center gap-1 border-b px-2 py-1 bg-muted/40">
          <button
            type="button"
            className={toolbarButtonBase}
            onClick={() => exec("bold")}
          >
            <span className="font-bold">B</span>
          </button>
          <button
            type="button"
            className={toolbarButtonBase}
            onClick={() => exec("italic")}
          >
            <span className="italic">I</span>
          </button>
          <button
            type="button"
            className={toolbarButtonBase}
            onClick={() => exec("underline")}
          >
            <span className="underline">U</span>
          </button>
          <span className="mx-1 h-4 w-px bg-border" />
          <button
            type="button"
            className={toolbarButtonBase}
            onClick={() => exec("insertUnorderedList")}
          >
            <span>• •</span>
          </button>
          <button
            type="button"
            className={toolbarButtonBase}
            onClick={() => exec("insertOrderedList")}
          >
            <span>1.</span>
          </button>
          <span className="mx-1 h-4 w-px bg-border" />
          <button
            type="button"
            className={toolbarButtonBase}
            onClick={() => execBlock("P")}
          >
            <span>P</span>
          </button>
          <button
            type="button"
            className={toolbarButtonBase}
            onClick={() => execBlock("H2")}
          >
            <span className="font-semibold text-xs">H2</span>
          </button>
        </div>
        <div
          ref={editorRef}
          className={cn(
            "min-h-[140px] bg-white text-black max-h-[360px] overflow-auto px-3 py-2 text-sm focus-visible:outline-none",
            "prose prose-sm [&_p]:my-1 [&_ul]:my-1 [&_ol]:my-1"
          )}
          contentEditable
          onInput={handleInput}
          data-placeholder={placeholder}
          suppressContentEditableWarning
        />
      </div>
    );
  }
);

RichTextEditor.displayName = "RichTextEditor";


